// extracted by mini-css-extract-plugin
export default {"container":"style_container__4Rw1c","containerVertical":"style_containerVertical__qw7M8","player":"style_player__rqkVB","spinnerContainer":"style_spinnerContainer__HREMU"};